export default {
  AC: 'Pulau Ascension',
  AD: 'Andorra',
  AE: 'Uni Emirat Arab',
  AF: 'Afghanistan',
  AG: 'Antigua dan Barbuda',
  AI: 'Anguilla',
  AL: 'Albania',
  AM: 'Armenia',
  AN: 'Antillen Belanda',
  AO: 'Angola',
  AQ: 'Antartika',
  AR: 'Argentina',
  AS: 'Samoa Amerika',
  AT: 'Austria',
  AU: 'Australia',
  AW: 'Aruba',
  AX: 'Kepulauan Åland',
  AZ: 'Azerbaijan',
  BA: 'Bosnia dan Herzegovina',
  BB: 'Barbados',
  BD: 'Bangladesh',
  BE: 'Belgia',
  BF: 'Burkina Faso',
  BG: 'Bulgaria',
  BH: 'Bahrain',
  BI: 'Burundi',
  BJ: 'Benin',
  BL: 'Saint Barthélemy',
  BM: 'Bermuda',
  BN: 'Brunei',
  BO: 'Bolivia',
  BQ: 'Belanda Karibia',
  BR: 'Brasil',
  BS: 'Bahama',
  BT: 'Bhutan',
  BV: 'Pulau Bouvet',
  BW: 'Botswana',
  BY: 'Belarus',
  BZ: 'Belize',
  CA: 'Kanada',
  CC: 'Kepulauan Cocos [Keeling]',
  CD: 'Kongo - Kinshasa',
  CF: 'Republik Afrika Tengah',
  CG: 'Kongo - Brazzaville',
  CH: 'Swiss',
  CI: 'Pantai Gading',
  CK: 'Kepulauan Cook',
  CL: 'Chili',
  CM: 'Kamerun',
  CN: 'Tiongkok',
  CO: 'Kolombia',
  CP: 'Pulau Clipperton',
  CR: 'Kosta Rika',
  CU: 'Kuba',
  CV: 'Tanjung Verde',
  CW: 'Curaçao',
  CX: 'Pulau Natal',
  CY: 'Siprus',
  CZ: 'Republik Ceko',
  DE: 'Jerman',
  DG: 'Diego Garcia',
  DJ: 'Djibouti',
  DK: 'Denmark',
  DM: 'Dominika',
  DO: 'Republik Dominika',
  DZ: 'Aljazair',
  EA: 'Ceuta dan Melilla',
  EC: 'Ekuador',
  EE: 'Estonia',
  EG: 'Mesir',
  EH: 'Sahara Barat',
  ER: 'Eritrea',
  ES: 'Spanyol',
  ET: 'Etiopia',
  EU: 'Uni Eropa',
  FI: 'Finlandia',
  FJ: 'Fiji',
  FK: 'Kepulauan Falkland',
  FM: 'Mikronesia',
  FO: 'Kepulauan Faroe',
  FR: 'Perancis',
  GA: 'Gabon',
  GB: 'Britania Raya',
  GD: 'Grenada',
  GE: 'Georgia',
  GF: 'Guyana Perancis',
  GG: 'Guernsey',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GL: 'Greenland',
  GM: 'Gambia',
  GN: 'Guinea',
  GP: 'Guadeloupe',
  GQ: 'Guinea Khatulistiwa',
  GR: 'Yunani',
  GS: 'Georgia Selatan dan Kepulauan Sandwich Selatan',
  GT: 'Guatemala',
  GU: 'Guam',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HK: 'Hongkong',
  HM: 'Pulau Heard dan Kepulauan McDonald',
  HN: 'Honduras',
  HR: 'Kroasia',
  HT: 'Haiti',
  HU: 'Hongaria',
  IC: 'Kepulauan Canaria',
  ID: 'Indonesia',
  IE: 'Irlandia',
  IL: 'Israel',
  IM: 'Pulau Man',
  IN: 'India',
  IO: 'Wilayah Samudra Hindia Britania',
  IQ: 'Irak',
  IR: 'Iran',
  IS: 'Islandia',
  IT: 'Italia',
  JE: 'Jersey',
  JM: 'Jamaika',
  JO: 'Yordania',
  JP: 'Jepang',
  KE: 'Kenya',
  KG: 'Kirgistan',
  KH: 'Kamboja',
  KI: 'Kiribati',
  KM: 'Komoro',
  KN: 'Saint Kitts dan Nevis',
  KP: 'Korea Utara',
  KR: 'Korea Selatan',
  KW: 'Kuwait',
  KY: 'Kepulauan Cayman',
  KZ: 'Kazakhstan',
  LA: 'Laos',
  LB: 'Libanon',
  LC: 'Saint Lucia',
  LI: 'Liechtenstein',
  LK: 'Sri Lanka',
  LR: 'Liberia',
  LS: 'Lesotho',
  LT: 'Lithuania',
  LU: 'Luksemburg',
  LV: 'Latvia',
  LY: 'Libya',
  MA: 'Maroko',
  MC: 'Monako',
  MD: 'Moldova',
  ME: 'Montenegro',
  MF: 'Saint Martin',
  MG: 'Madagaskar',
  MH: 'Kepulauan Marshall',
  MK: 'Makedonia',
  ML: 'Mali',
  MM: 'Myanmar [Burma]',
  MN: 'Mongolia',
  MO: 'Makau',
  MP: 'Kepulauan Mariana Utara',
  MQ: 'Martinik',
  MR: 'Mauritania',
  MS: 'Montserrat',
  MT: 'Malta',
  MU: 'Mauritius',
  MV: 'Maladewa',
  MW: 'Malawi',
  MX: 'Meksiko',
  MY: 'Malaysia',
  MZ: 'Mozambik',
  NA: 'Namibia',
  NC: 'Kaledonia Baru',
  NE: 'Niger',
  NF: 'Pulau Norfolk',
  NG: 'Nigeria',
  NI: 'Nikaragua',
  NL: 'Belanda',
  NO: 'Norwegia""',
  NP: 'Nepal',
  NR: 'Nauru',
  NU: 'Niue',
  NZ: 'Selandia Baru',
  OM: 'Oman',
  PA: 'Panama',
  PE: 'Peru',
  PF: 'Polinesia Perancis',
  PG: 'Papua Nugini',
  PH: 'Filipina',
  PK: 'Pakistan',
  PL: 'Polandia',
  PM: 'Saint Pierre dan Miquelon',
  PN: 'Kepulauan Pitcairn',
  PR: 'Puerto Riko',
  PS: 'Teritori Palestina',
  PT: 'Portugal',
  PW: 'Palau',
  PY: 'Paraguay',
  QA: 'Qatar',
  QO: 'Oseania Terluar',
  RE: 'Réunion',
  RO: 'Rumania',
  RS: 'Serbia',
  RU: 'Rusia',
  RW: 'Rwanda',
  SA: 'Arab Saudi',
  SB: 'Kepulauan Solomon',
  SC: 'Seychelles',
  SD: 'Sudan',
  SE: 'Swedia',
  SG: 'Singapura',
  SH: 'Saint Helena',
  SI: 'Slovenia',
  SJ: 'Svalbard dan Jan Mayen',
  SK: 'Slowakia',
  SL: 'Sierra Leone',
  SM: 'San Marino',
  SN: 'Senegal',
  SO: 'Somalia',
  SR: 'Suriname',
  SS: 'Sudan Selatan',
  ST: 'São Tomé dan Príncipe',
  SV: 'El Salvador',
  SX: 'Sint Maarten',
  SY: 'Suriah',
  SZ: 'Swaziland',
  TA: 'Tristan da Cunha',
  TC: 'Kepulauan Turks dan Caicos',
  TD: 'Chad',
  TF: 'Teritori Selatan Prancis',
  TG: 'Togo',
  TH: 'Thailand',
  TJ: 'Tajikistan',
  TK: 'Tokelau',
  TL: 'Timor-Leste',
  TM: 'Turkmenistan',
  TN: 'Tunisia',
  TO: 'Tonga',
  TR: 'Turki',
  TT: 'Trinidad dan Tobago',
  TV: 'Tuvalu',
  TW: 'Taiwan',
  TZ: 'Tanzania',
  UA: 'Ukraina',
  UG: 'Uganda',
  UM: 'Kepulauan Terluar AS',
  US: 'Amerika Serikat',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VA: 'Kota Vatikan',
  VC: 'Saint Vincent dan Grenadines',
  VE: 'Venezuela',
  VG: 'Kepulauan Virgin Inggris',
  VI: 'Kepulauan Virgin AS',
  VN: 'Vietnam',
  VU: 'Vanuatu',
  WF: 'Wallis dan Futuna',
  WS: 'Samoa',
  YE: 'Yaman',
  YT: 'Mayotte',
  ZA: 'Afrika Selatan',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
  ZZ: 'Wilayah Tidak Diketahui',
};
